// Central contact constants used across the site
export const PHONE_DISPLAY = "0479 070 132";
export const PHONE_HREF = "tel:0479070132";
export const EMAIL = "hire@tippingpointskips.com.au";
export const EMAIL_HREF = "mailto:hire@tippingpointskips.com.au";
export const ABN = "39 893 342 288";
export const SERVICE_AREA = "Sydney, all suburbs";
export const BUSINESS_NAME = "Tipping Point Skips";
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_skip-hire-sydney/artifacts/21plgv69_logo_use%20this.jpeg";
